// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__l0O4W","left":"InfoRow_left__2TvLC"};